import React from 'react'
import { Switch } from '@mui/material'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import { setloftUnavailableModalOpenModalOpen } from '../../store/ui/uiSlice'

import LoftUnavailableModal from '../Modals/LoftUnavailableModal'
import Card from '../Card/Card'
import SwitchLabel from '../SwitchLabel/SwitchLabel'

import * as Styled from '../styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

// TODO--låg-prio slå ihop komponent med SizePanel!
const ASSEMBLY_ID = 'assembly'

const RoofKindPanel: React.FC = () => {
  const configurator = useConfiguratorContext()
  const dispatch = useAppDispatch()

  const {
    meta: { roofAngle },
    props: { roofKind, roofExtraHeight, loftLeft, loftRight },
  } = useAppSelector((state) => state.configResult) as any
  const { assetBaseUrl, content } = useAppSelector((state) => state.init)

  const isRoofExtraHeightDisabled = !roofExtraHeight.options.find((option: any) => option.value === true).available

  return (
    <>
      <LoftUnavailableModal />

      <Styled.Panel>
        <Styled.Grid $responsive>
          {roofKind.options.map((option: any) => (
            <Card
              key={option.value}
              type="lightweight"
              isSelected={option.value === roofKind.value}
              onClick={() => {
                if (option.value === 'gable' && (loftLeft.value || loftRight.value)) {
                  dispatch(setloftUnavailableModalOpenModalOpen(true))
                } else {
                  configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
                    roofKind: option.value,
                  })
                }
              }}
              dangerouslySetInfo={content.props.roofKind.options[option.value].description}
              mediaAlt={content.props.roofKind.options[option.value].title}
              mediaImage={`${assetBaseUrl}${content.props.roofKind.options[option.value].image}`}
              title={content.props.roofKind.options[option.value].title}
              titleLong={content.props.roofKind.options[option.value].description}
            />
          ))}
        </Styled.Grid>
        <SwitchLabel
          htmlFor="roofExtraHeight"
          disabled={isRoofExtraHeightDisabled}
          label={content.props.roofExtraHeight.title}
          info={content.props.roofExtraHeight.description}
        >
          <Switch
            id="roofExtraHeight"
            disabled={isRoofExtraHeightDisabled}
            checked={roofExtraHeight.value}
            onChange={() => {
              configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
                roofExtraHeight: !roofExtraHeight.value,
              })
            }}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </SwitchLabel>

        <span>
          {content.meta.roofAngle.title}: <strong>{roofAngle}°</strong>
        </span>
      </Styled.Panel>
    </>
  )
}

export default RoofKindPanel
